import * as React from 'react'
import { lazy } from 'react'

import type { MenusNavItem } from '@/common/types'
import { lazyRetry } from '@/core'

type View = {
  views?: MenusNavItem[]
  action?: () => void
} & Record<string, unknown>

const importView = (components: MenusNavItem['component']) => lazy(() => lazyRetry(components))

export const loadViews = async ({ views, action, ...rest }: View): Promise<JSX.Element[]> => {
  const componentPromises = views?.map(async ({ index, props, component }, position) => {
    const View = importView(component)

    const viewProps = {
      action: action,
      ...props,
      ...rest,
    }

    return <View {...viewProps} key={index ?? position} />
  })

  return componentPromises ? Promise.all(componentPromises) : []
}
